import { TextField as MUITextField, outlinedInputClasses as MUIoutlinedInputClasses, textFieldClasses as MUItextFieldClasses, formHelperTextClasses as MUIformHelperTextClasses, inputBaseClasses as MUIinputBaseClasses, inputLabelClasses as MUIinputLabelClasses, styled, } from '@mui/material';
export const StyledTextField = styled(MUITextField)(({ theme }) => {
    return {
        [`&.${MUItextFieldClasses.root}`]: {
            [`& .${MUIinputBaseClasses.multiline}`]: {
                padding: 0,
            },
            [`& .${MUIinputLabelClasses.root}`]: {
                transform: 'translate(16px, 15.5px) scale(1)',
                [`&.${MUIinputLabelClasses.sizeSmall}`]: {
                    transform: 'translate(16px, 10px) scale(1)',
                },
                fontSize: theme.typography['uikit-body2'].fontSize,
                fontWeight: theme.typography['uikit-body2'].fontWeight,
                lineHeight: theme.typography['uikit-body2'].lineHeight,
                [`&.${MUIinputLabelClasses.shrink}`]: {
                    transform: 'translate(14px, -7px) scale(0.8)',
                },
            },
            [`& .${MUIoutlinedInputClasses.root}`]: {
                borderRadius: theme.shape.borderRadius * 2,
                transition: theme.transitions.create(['background', 'box-shadow']),
                [`&:hover`]: {
                    [`&:not(.Mui-focused)`]: {
                        outline: '4px solid #e7eff9',
                        [`& .${MUIoutlinedInputClasses.notchedOutline}`]: {
                            borderColor: '#CEDDF3',
                        },
                    },
                },
                [`& .${MUIoutlinedInputClasses.input}`]: {
                    borderRadius: theme.shape.borderRadius * 2,
                    padding: theme.spacing(1.9375, 2),
                    fontSize: theme.typography['uikit-body2'].fontSize,
                    fontWeight: theme.typography['uikit-body2'].fontWeight,
                    lineHeight: theme.typography['uikit-body2'].lineHeight,
                    height: 17,
                    [`&.${MUIinputBaseClasses.inputSizeSmall}`]: {
                        padding: theme.spacing(1.4375, 1.75),
                        fontSize: theme.typography['uikit-body2'].fontSize,
                        fontWeight: theme.typography['uikit-body2'].fontWeight,
                        lineHeight: theme.typography['uikit-body2'].lineHeight,
                        height: 17,
                    },
                    [`&.${MUIinputBaseClasses.inputMultiline}`]: {
                        resize: 'both',
                    },
                    [`&.${MUIinputBaseClasses.inputAdornedStart}`]: {
                        paddingLeft: theme.spacing(1.5),
                    },
                    [`&.${MUIinputBaseClasses.inputAdornedEnd}`]: {
                        paddingRight: theme.spacing(1.5),
                    },
                },
            },
            [`& .${MUIformHelperTextClasses.root}`]: {
                fontSize: theme.typography['uikit-caption'].fontSize,
                fontWeight: theme.typography['uikit-caption'].fontWeight,
                lineHeight: theme.typography['uikit-caption'].lineHeight,
            },
        },
        [`& .${MUIoutlinedInputClasses.notchedOutline}`]: {
            borderColor: theme.palette.divider,
        },
    };
});
